import { render } from "./HomeView.vue?vue&type=template&id=0bdff078&scoped=true&ts=true"
import script from "./HomeView.ts?vue&type=script&lang=ts"
export * from "./HomeView.ts?vue&type=script&lang=ts"

import "./HomeView.scss?vue&type=style&index=0&id=0bdff078&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdff078"]])

export default __exports__